import { improvedFetch2 } from "../../components/fetch";
import { FetchError } from "../errors";

import { LegalEntity } from "./types";

export const getAllLegalEntites: () => Promise<LegalEntity[]> = () =>
  improvedFetch2(`/2/legal-entities`).then(res => {
    if (!res.ok) {
      throw new FetchError();
    }
    return res.json();
  });
